import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { AdminAPI } from '@guestgoodie/graphql'

import { Permission, useCheckPermission } from '@/features/auth'

export function useHasUnreadFeedbacks() {
  const canSeeFeedbacks = useCheckPermission([Permission.FEEDBACK_READ])

  const { data } = useQuery(AdminAPI.simpleFeedback.UNREAD_COUNT, {
    errorPolicy: canSeeFeedbacks ? 'all' : 'ignore'
  })

  return useMemo(() => {
    if (!canSeeFeedbacks) return false
    if (!data) return false

    return data.unreadFeedbackCount > 0
  }, [data, canSeeFeedbacks])
}
